import {
  AddCircle,
  AssignmentTurnedIn,
  Description,
  SupervisedUserCircle,
} from '@mui/icons-material'
import { tsMenuItem } from '../../Typescript/UI_Interfaces'
import { useUserContext } from '../../Contexts/UserConfig'
import { UseQueryResult } from 'react-query'

export function useHealthMenuItems(screensQuery: UseQueryResult<any>) {
  const { loginConfig } = useUserContext()
  const items: tsMenuItem[] = [
    {
      path: '/stuart/health/complete',
      primaryText: 'Screens To Collect',
      leftIcon: <AssignmentTurnedIn />,
      badgeCount:
        screensQuery.data?.Screens ? screensQuery.data.Screens.length : 0,
    },
    {
      path: '/stuart/health/screen',
      primaryText: 'New Screen Request',
      leftIcon: <AddCircle />,
      permission: !!loginConfig?.Modules?.NewScreenRequest,
    },
    {
      path: '/stuart/health/manage',
      primaryText: 'Manage Screens',
      leftIcon: <SupervisedUserCircle />,
      permission: !!loginConfig?.Modules?.ViewScreenRequest,
    },
    {
      path: '/stuart/health/report/manifest',
      primaryText: 'Manifest Report',
      leftIcon: <Description />,
      permission: !!loginConfig?.Modules?.ViewScreenRequest,
    },
    {
      path: '/stuart/health/report/screen',
      primaryText: 'Screen Report',
      leftIcon: <Description />,
      permission: !!loginConfig?.Modules?.ViewScreenRequest,
    },
    {
      path: '/stuart/health/report/results',
      primaryText: 'Result Report',
      leftIcon: <Description />,
      permission: !!loginConfig?.Modules?.ViewScreenRequest,
    },
  ]
  return items
}
